module.exports = __webpack_public_path__ + "static/img/logo.bef42e26.png";